module.exports = __webpack_public_path__ + "assets/img/average_text.cea13b03.svg";